import React, { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [currentLang, setCurrentLang] = useState(() => {
    // Default role if localStorage is empty
    return localStorage.getItem("preferredLanguage") || "en";
  });

  const updateCurrentLang = (currentLanguage) => {
    localStorage.setItem("preferredLanguage", currentLanguage); // Sync with localStorage
    setCurrentLang(currentLanguage); // Update state
  };

  useEffect(() => {
    // Sync context state with localStorage on mount
    const storedCurrentLanguage =
      localStorage.getItem("preferredLanguage") || "en";
    if (storedCurrentLanguage && storedCurrentLanguage !== currentLang) {
      setCurrentLang(storedCurrentLanguage);
    }
  }, [currentLang]);

  return (
    <AuthContext.Provider value={{ currentLang, updateCurrentLang }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
